// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { loadingToggler } from 'redux/modules/loading'
import { setPcnRenewalData } from 'redux/modules/projectTracker/actions'

import {
  fetchWrapper,
  assembleQuery,
} from 'helpers/api'

const getPcnRenewalData = (ignoreCache = false) => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const { pcnRenewal } = getState().projectTracker

      // if the data isn't expired yet, just return what we have in redux store.
      if (ignoreCache === false && pcnRenewal.dataExpiration > Date.now()) {
        return pcnRenewal.data
      }

      try {
        // assembleQuery generates a timestamped query parameter string
        // even when no arguments are passed.
        const query = assembleQuery()
        // we use the timestamped query parameter (expires) here to bust IE's internal browser cache.
        // and fetch the updated data from the API.
        const data = await fetchWrapper(`/pcnRenewal${query}`)
        dispatch(setPcnRenewalData(data.map(d => {
          // the JSON has this value as a String when it should be a Float/Double.
          d.band_id = parseFloat(d.band_id)
          return d
        })))
        return data
      } catch (err) {
        throw err
      }
    })
  )
)

export default getPcnRenewalData
